@defer (on viewport) {
  @if (isBrowser) {
    <div class="carousel__wrapper">
      <h2 class="carousel__title" [attr.data-translate]="'title.news'">{{ title }}</h2>
      <p *ngIf="newsSubtitle" class="carousel__description" [attr.data-translate]="'public.commons.news.subtitle'">
        {{ newsSubtitle }}
      </p>
      @if (viewAllLink) {
        <a class="carousel__view-all hyperlink" i18n="View all button@@button.view-all" [routerLink]="viewAllLink"
          >View all</a
        >
      }
      <button pButton [id]="arrowLeftCssSelector" class="carousel__arrow carousel__left-arrow">
        <ush-arrow [template]="arrowTemplate" orientation="left"></ush-arrow>
      </button>
      <button pButton [id]="arrowRightCssSelector" class="carousel__arrow carousel__right-arrow">
        <ush-arrow [template]="arrowTemplate" orientation="right"></ush-arrow>
      </button>
      <div class="carousel__content">
        @if (news$ | async; as news) {
          <swiper-container #swiper ushSwiperElement [config]="swiperConfig" init="false">
            <swiper-slide *ngFor="let newsItem of news" lazy="true">
              <community-elements-ui-news-card [news]="newsItem"></community-elements-ui-news-card>
            </swiper-slide>
          </swiper-container>
        }
      </div>
    </div>
  } @else {
    <div class="carousel__wrapper"></div>
  }
} @placeholder {
  <div style="height: 400px; width: 100%; background: transparent"></div>
}
